import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Uploader from '../../../../../core/components/Uploaders/Uploader';
import File from '../../../../../core/components/Uploaders/File';
const StylesFileRows = styled.div `
  display: grid;
  grid-template-columns: 100%;
  grid-gap: 0.5em;
  min-height: 1em;
  margin-bottom: 1rem;
  ${({ uploadLoading }) => uploadLoading && `cursor: wait !important;`}
`;
const FileRows = ({ uploading, uploaded, progress, removeFile, uploadLoading, rejected, retry, rowDataQaAnchor, }) => (React.createElement(StylesFileRows, { uploadLoading: uploadLoading },
    uploaded.map((file) => (React.createElement(File, { key: file.fileId, "data-qa-anchor": rowDataQaAnchor, fileId: file.fileId, onRemove: () => removeFile(file) }))),
    uploading.map((file) => (React.createElement(File, { key: file.name, "data-qa-anchor": rowDataQaAnchor, file: file, progress: progress[file.name], isRejected: rejected.includes(file.name), retry: retry, onRemove: () => removeFile(file) })))));
const Files = ({ files, onChange, onLoadingChange, uploadLoading, onError, rowDataQaAnchor = 'post-creator-uploaded-file', }) => (React.createElement(Uploader, { files: files, onChange: onChange, onLoadingChange: onLoadingChange, onError: onError },
    React.createElement(FileRows, { uploadLoading: uploadLoading, rowDataQaAnchor: rowDataQaAnchor })));
Files.propTypes = {
    files: PropTypes.array,
    uploadLoading: PropTypes.bool,
    rowDataQaAnchor: PropTypes.string,
    onLoadingChange: PropTypes.func,
    onChange: PropTypes.func,
    onError: PropTypes.func,
};
Files.defaultProps = {
    files: [],
    onChange: () => { },
    onError: () => { },
    onLoadingChange: () => { },
    uploadLoading: false,
    rowDataQaAnchor: undefined,
};
export default Files;
//# sourceMappingURL=FilesUploaded.js.map